import { LIST_TYPES } from './BlockButton';

const isList = (type: string) => LIST_TYPES.some((listType) => listType === type);

export default isList;
